import { Directive, inject, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BezugsrechtService } from '@zero/bezugsrecht/domain';
import { commonRoutes } from 'constants/web-app-constants';

@Directive()
export class TeilrechtPageBase implements OnInit, OnDestroy {
  public commonRoutes = commonRoutes;

  private readonly _service = inject(BezugsrechtService);
  private readonly _route = inject(ActivatedRoute);
  private readonly _router = inject(Router);

  public ngOnInit(): void {
    const { params } = this._route;

    params.subscribe((param) => {
      const isin = param['id'];
      if (!isin) {
        this._router.navigate([commonRoutes.postlogin.member_home]);
      } else {
        this._service.loadData(isin);
      }
    });
  }

  public ngOnDestroy(): void {
    this._service.clear();
  }
}
